import { ApiDOMError } from '@swagger-api/apidom-error';
class ResolveError extends ApiDOMError {}
export default ResolveError;